import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const SiteAnalyticsPageLoader: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsSiteAnalyticsPage" */ '../src/components/SiteAnalytics/SiteAnalyticsPage.tsx'
			)
		).SiteAnalyticsPage,
});
